export default __webpack_public_path__ + "static/media/lsdc-logo.a0ea6d82.png";